export default "__VITE_PUBLIC_ASSET__5afb7393__"